import { FormikProps } from "formik";
import { Dispatch, SetStateAction } from "react";
import { FreelancerProfile } from "../../../../../models/FreelancerProfile";
import { FreelancerOnboardingMyPresentationStepViewModel } from "../../../../../ViewModels/FreelancerOnboardingMyPresentationStepViewModel";
import ExperienceListContainer from ".";
import { useTranslatableForm } from "../../../../../hooks/useTranslatableForm";

interface FreelancerOnboardingExperiencesSectionProps {
	readonly formik: FormikProps<FreelancerOnboardingMyPresentationStepViewModel>;
	readonly freelancerProfile: FreelancerProfile;
	readonly setExperienceEditMode: Dispatch<
		SetStateAction<{
			[key: number]: boolean;
		}>
	>;
	readonly experienceEditMode: {
		[key: number]: boolean;
	};
	readonly setIsCityValueChangedOnLoadBecauseOfBeingTranslated: Dispatch<
		SetStateAction<boolean>
	>;
	readonly experienceTranslatableFormsRef?: React.MutableRefObject<Record<number, ReturnType<typeof useTranslatableForm> | null>>;
}

export default function FreelancerOnboardingMyPresentationExperiencesBloc({
	formik,
	freelancerProfile,
	setExperienceEditMode,
	experienceEditMode,
	setIsCityValueChangedOnLoadBecauseOfBeingTranslated,
	experienceTranslatableFormsRef
}: FreelancerOnboardingExperiencesSectionProps) {
	return (
		<ExperienceListContainer
			formik={formik}
			freelancerProfile={freelancerProfile}
			setExperienceEditMode={setExperienceEditMode}
			experienceEditMode={experienceEditMode}
			setIsCityValueChangedOnLoadBecauseOfBeingTranslated={
				setIsCityValueChangedOnLoadBecauseOfBeingTranslated
			}
			experienceTranslatableFormsRef={experienceTranslatableFormsRef}
		/>
	);
}
